const UserUnitService = {
    // System temperature units are always C
    // User temperature unit could be C or F

    convertFromSystemUnitToUserUnit: (userUnit, valueInC) => {
        if (isNaN(valueInC)) {
            return valueInC;
        }
        if (userUnit == "F") {
            return Math.round(((valueInC * 9) / 5 + 32) * 100) / 100;
        } else {
            return valueInC;
        }
    },

    convertFromUserUnitToSystemUnit: (userUnit, valueInUserUnits) => {
        if (isNaN(valueInUserUnits)) {
            return valueInUserUnits;
        }
        if (userUnit == "F") {
            return Math.round((valueInUserUnits - 32) * (5 / 9) * 100) / 100;
        } else {
            return valueInUserUnits;
        }
    },
};


export default UserUnitService;